<template>
	<BackButton :text="t('back_button.overview')" link="Home" />
	<!-- <InfoButton @click="showOverlay" /> -->
	<OverviewOverlay :scrollHint="showScrollHint()" v-if="overlayVisible" @click="hideOverlay" />
	<div v-if="te('gallery')" class="container-fluid h-100 w-100">
		<h3 class="text-center museum-titel-test">{{ t('photo_gallery')}}</h3>
		<div class="d-flex">
			<div class="gallery-grid mx-auto">
				<GalleryOverviewItem v-for="(gallery, index) in galleries" :key="gallery" :Overlay="index == 0 && overlayVisible" :title="gallery.post_title" :id="gallery._id" :image="gallery.thumbnail" :total="gallery.gallery.length"/>
			</div>
		</div>
	</div>
</template>

<script>
import { useI18n } from "vue-i18n";
import { useRoute } from 'vue-router';
import GalleryOverviewItem from "@/components/gallery/OverviewItem.vue";
import BackButton from "@/components/buttons/BackButton.vue";
import OverviewOverlay from "@/components/gallery/OverviewOverlay.vue";
import InfoButton from "@/components/buttons/InfoButton.vue";

export default {
	name: "GalleryOverview",
	components: {
		GalleryOverviewItem,
		BackButton,
		OverviewOverlay,
		InfoButton,
	},
	setup() {
		const { t, te, tm } = useI18n();
		return { t, te, tm };
	},
	computed: {
		galleries: () => {
			const { tm } = useI18n();
			const route = useRoute();  

			let galleries = tm('gallery');

			let categories = route.params.categories;

			if( categories === undefined || categories.length == 0 )
			{
				return galleries;
			}

			return galleries.filter(function(gallery) {
				return categories.split(',').find(e => e === gallery.category);
			});
		}
	},
	mounted() {
	},
	methods: {
		hasCategory(categories, category) {
			// If no categories, we just show all
			if( categories === undefined || categories.length == 0 )
			{
				return true;
			}

			return categories.split(',').find(e => e === category);
		}
	}
};
</script>

<style scoped>
.gallery-grid {
	margin-top: 240px;
	display: grid;
	grid-template-columns: auto auto;
	grid-template-rows: repeat(auto-fill, 360px);
	column-gap: 41px;
	margin-bottom: 140px;
}

</style>